var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKelvin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5C9 8.32843 8.32843 9 7.5 9ZM12.2082 16.9133C12.2082 17.5942 11.8358 17.9931 11.2041 17.9931C10.5724 17.9931 10.2 17.5942 10.2 16.9133V8.88672C10.2 8.19892 10.5724 7.8 11.2041 7.8C11.8358 7.8 12.2082 8.19892 12.2082 8.88672V12.3257H12.268L15.8788 8.24707C16.1581 7.93068 16.4107 7.8 16.7432 7.8C17.2752 7.8 17.6875 8.21955 17.6875 8.75603C17.6875 9.04491 17.5877 9.27188 17.335 9.547L14.6885 12.4151L17.5678 16.0329C17.867 16.4181 18 16.7138 18 16.9958C18 17.5598 17.5811 18 17.0292 18C16.6169 18 16.3376 17.8418 16.0251 17.4291L13.1657 13.7907L12.2082 14.8293V16.9133Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKelvin);
export default __webpack_public_path__ + "static/media/kelvin.138ff501f5d3c23c829a578cb364c5b4.svg";
export { ForwardRef as ReactComponent };